import { createClient } from '@supabase/supabase-js';

import { env } from '@/env.js';

const supabaseUrl = env.VITE_SUPABASE_URL;
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Create a proxy for localStorage to log all storage operations
const createStorageProxy = (storage: Storage): Storage => {
  return new Proxy(storage, {
    get(target, prop) {
      const value = target[prop as keyof Storage];

      if (typeof value === 'function') {
        return function (...args: unknown[]) {
          const methodName = prop as string;
          const key = args[0];

          try {
            const result = (value as Function).apply(target, args);

            // Log async results for async methods
            if (result instanceof Promise) {
              return result
                .then(res => {
                  return res;
                })
                .catch(err => {
                  console.error(
                    '[SupabaseStorage] Action Error:',
                    methodName,
                    'Key:',
                    key,
                    'Error:',
                    err
                  );
                  throw err;
                });
            }

            return result;
          } catch (error) {
            console.error(
              '[SupabaseStorage] Action Error:',
              methodName,
              'Key:',
              key,
              'Error:',
              error
            );
            throw error;
          }
        };
      }

      return value;
    },
  });
};

// Create proxied localStorage
const proxiedLocalStorage = createStorageProxy(localStorage);

// Create Supabase client with proxied storage and stack trace logging
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: {
      getItem: (key: string) => {
        return proxiedLocalStorage.getItem(key);
      },
      setItem: (key: string, value: string) => {
        return proxiedLocalStorage.setItem(key, value);
      },
      removeItem: (key: string) => {
        return proxiedLocalStorage.removeItem(key);
      },
    },
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce', // 2026 Enterprise SPA Security Standard
  },
});


